import TaxanomyInput from "./taxonomy-input";

export default TaxanomyInput;